import SelectPosition from './SelectPosition.view';

export default SelectPosition;
